export enum KeyboardSensorID
{
  None,
  Unknown,
  Custom,

  PrimaryModifier,
  SecondModifier,

  Control,
  Shift,
  Alt,
  
  Meta,
  
  Escape,

  Space,
  Enter,
  
  Backspace,
  
  Insert, 
  Delete,

  Arrow_Up,
  Arrow_Left,
  Arrow_Down,
  Arrow_Right,

  Key_A,
  Key_B,
  Key_C,
  Key_D,
  Key_E,
  Key_F,
  Key_G,
  Key_H,
  Key_I,
  Key_J,
  Key_K,
  Key_L,
  Key_M,
  Key_N,
  Key_O,
  Key_P,
  Key_Q,
  Key_R,
  Key_S,
  Key_T,
  Key_U,
  Key_V,
  Key_W,
  Key_X,
  Key_Y,
  Key_Z,

  Digit_1,
  Digit_2,
  Digit_3,
  Digit_4,
  Digit_5,
  Digit_6,
  Digit_7,
  Digit_8,
  Digit_9,
  Digit_0,

  F1,
  F2,
  F3,
  F4,
  F5,
  F6,
  F7,
  F8,
  F9,
  F10,
  F11,
  F12

}